import { useRef, useState, useEffect } from 'react';
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"
import SelectControl from "../../../Controls/SelectControl"
import { useNavigate } from "react-router-dom";

import {
	GetLocal,
	SetLocal,
	FetchService,
	GetParamsUrl
} from "../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

let ServiceUrlCheckBox = '';
export default function Index(props) {
	const inputRef = useRef(null);
	const navigate = useNavigate();

	const inp1Ref = useRef(null);
	const inp2Ref = useRef(null);
	const inp3Ref = useRef(null);
	const inp4Ref = useRef(null);
	const inp5Ref = useRef(null);
	const inp6Ref = useRef(null);
	const inp7Ref = useRef(null);
	const inp8Ref = useRef(null);
	const inp9Ref = useRef(null);
	const inp10Ref = useRef(null);
	const inp11Ref = useRef(null);
	const inp12Ref = useRef(null);
	const inp13Ref = useRef(null);
	const inp14Ref = useRef(null);
	const inp15Ref = useRef(null);
	const inp16Ref = useRef(null);
	const inp17Ref = useRef(null);
	const inp18Ref = useRef(null);
	const btnSearchRef = useRef(null);

	const [value, setValue] = useState(0);
	const inpTelRef = useRef(null);
	const [getServiceResult, setServiceResult] = useState(false);
	const [getSelectData, setSelectData] = useState([]);

	const [getFileNumberState, setFileNumberState] = useState(true);
	const [getRegistrationPlateState, setRegistrationPlateState] = useState(true);
	const [getRenewalCodeState, setRenewalCodeState] = useState(true);
	const [getOldRenovationCodeState, setOldRenovationCodeState] = useState(true);
	const [getOwnerNameState, setOwnerNameState] = useState(true);
	const [getOwnerAddressState, setOwnerAddressState] = useState(true);
	const [getPostalCodeState, setPostalCodeState] = useState(true);
	const [getNationalCodeState, setNationalCodeState] = useState(true);


	const ShowFilesOperationAbstractList = () => {
		var inputValue = {};
		FetchService("General/Abstract/ShowFilesOperationAbstractList", inputValue, ShowFilesOperationAbstractListSuccess);
	}

	useEffect(() => {
		ShowFilesOperationAbstractList()
	}, []);

	useEffect(() => {
		if (ServiceUrlCheckBox == 'GetFilesByFileNumber') {
			inp1Ref.current?.focus();
		}
		if (ServiceUrlCheckBox == 'GetFilesByRegistrationPlate')
			inp4Ref.current?.focus();
		if (ServiceUrlCheckBox == 'GetFilesByRenovationCode')
			inp9Ref.current?.focus();
		if (ServiceUrlCheckBox == 'GetFilesByOldRenovationCode')
			inp14Ref.current?.focus();
		if (ServiceUrlCheckBox == 'GetFilesByOwnerName')
			inp15Ref.current?.focus();
		if (ServiceUrlCheckBox == 'GetFilesByAddress')
			inp16Ref.current?.focus();
		if (ServiceUrlCheckBox == 'GetFilesByPostalCode')
			inp17Ref.current?.focus();
		if (ServiceUrlCheckBox == 'GetFilesByNationalCode')
			inp18Ref.current?.focus();
	}, [ServiceUrlCheckBox]);




	const BtnGetServiceResult = () => {
		if (ServiceUrlCheckBox == 'GetFilesByFileNumber')
			GetFilesByFileNumber();
		if (ServiceUrlCheckBox == 'GetFilesByRegistrationPlate')
			GetFilesByRegistrationPlate();
		if (ServiceUrlCheckBox == 'GetFilesByRenovationCode')
			GetFilesByRenovationCode();
		if (ServiceUrlCheckBox == 'GetFilesByOldRenovationCode')
			GetFilesByOldRenovationCode();
		if (ServiceUrlCheckBox == 'GetFilesByOwnerName')
			GetFilesByOwnerName();
		if (ServiceUrlCheckBox == 'GetFilesByAddress')
			GetFilesByAddress();
		if (ServiceUrlCheckBox == 'GetFilesByPostalCode')
			GetFilesByPostalCode();
		if (ServiceUrlCheckBox == 'GetFilesByNationalCode')
			GetFilesByNationalCode();
	}

	const ClearRefInput = () => {
		inp1Ref.current.value = "";
		inp2Ref.current.value = "";
		inp3Ref.current.value = "";
		inp4Ref.current.value = "";
		inp5Ref.current.value = "";
		inp6Ref.current.value = "";
		inp7Ref.current.value = "";
		inp8Ref.current.value = "";
		inp9Ref.current.value = "";
		inp10Ref.current.value = "";
		inp11Ref.current.value = "";
		inp12Ref.current.value = "";
		inp13Ref.current.value = "";
		inp14Ref.current.value = "";
		inp15Ref.current.value = "";
		inp16Ref.current.value = "";
		inp17Ref.current.value = "";
		inp18Ref.current.value = "";
	}

	const GetFilesByNationalCode = () => {
		if (inp18Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			nationalCode: inp18Ref.current.value
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByNationalCode", inputValue, GetFilesByNationalCodeSuccess, ServiceResultFail);
	}

	const GetFilesByNationalCodeSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.FilesInfo);
	}

	const GetFilesByPostalCode = () => {
		if (inp17Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			postalCode: inp17Ref.current.value
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByPostalCode", inputValue, GetFilesByPostalCodeSuccess, ServiceResultFail);
	}

	const GetFilesByPostalCodeSuccess = (ServiceResult) => {
		setServiceResult([ServiceResult]);
	}

	const GetFilesByAddress = () => {
		if (inp16Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			address: inp16Ref.current.value
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByAddress", inputValue, GetFilesByAddressSuccess, ServiceResultFail);
	}

	const GetFilesByAddressSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.FilesInfo);
	}

	const GetFilesByOwnerName = () => {
		if (inp15Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			ownerName: inp15Ref.current.value
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByOwnerName", inputValue, GetFilesByOwnerNameSuccess, ServiceResultFail);
	}

	const GetFilesByOwnerNameSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.FilesInfo);
	}

	const GetFilesByOldRenovationCode = () => {
		if (inp14Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			oldArea: String(inp14Ref.current.value),
			oldDistrict: String(inp13Ref.current.value),
			oldBlock: String(inp12Ref.current.value),
			oldParcel: String(inp11Ref.current.value),
			oldApartment: String(inp10Ref.current.value)
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByOldRenovationCode", inputValue, GetFilesByOldRenovationCodeSuccess, ServiceResultFail);
	}

	const GetFilesByOldRenovationCodeSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.FilesInfo);
	}

	const GetFilesByRenovationCode = () => {
		if (inp9Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			area: Number(inp9Ref.current.value),
			district: Number(inp8Ref.current.value),
			block: Number(inp7Ref.current.value),
			parcel: Number(inp6Ref.current.value),
			apartment: Number(inp5Ref.current.value)
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByRenovationCode", inputValue, GetFilesByRenovationCodeSuccess, ServiceResultFail);
	}

	const GetFilesByRenovationCodeSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.FilesInfo);
	}

	const GetFilesByRegistrationPlate = () => {
		if (inp4Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			primaryCode: inp4Ref.current.value,
			secondaryCode: inp3Ref.current.value,
			parcelCode: inp2Ref.current.value
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByRegistrationPlate", inputValue, GetFilesByRegistrationPlateSuccess, ServiceResultFail);
	}

	const GetFilesByRegistrationPlateSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.FilesInfo);
	}

	const GetFilesByFileNumber = () => {
		if (inp1Ref.current.value == '')
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: inp1Ref.current.value
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetFilesByFileNumber", inputValue, GetFilesByFileNumberSuccess, ServiceResultFail);
	}

	const GetFilesByFileNumberSuccess = (ServiceResult) => {
		setServiceResult([ServiceResult]);
	}

	const ServiceResultFail = (ServiceResult) => {
		setServiceResult([]);
	}

	const ComboBox = (value, i) => {

		return (
			<SelectControl
				data={getSelectData}
				onChange={OnchangeSelectControl.bind(i, value)}
			/>
		)

	}

	const ShowFilesOperationAbstractListSuccess = (ServiceResult) => {
		setSelectData(ServiceResult.OperationInfo);

		document.querySelector('input[type=radio]').click();
		document.querySelector('input[type=text]').focus();
	}

	const OnchangeSelectControl = (value, i) => {
		if (i == '')
			return;

		SetLocal('FileNumber', Number(value.FileNumber));

		switch (Number(i)) {
			case 1:
				navigate("/Employee/Requests?page=درخواست ها");
				break;
			case 2:
				navigate("/Employee/SubmitRequest?page=ثبت درخواست اینترنتی");
				break;
			case 3:
				navigate("/Employee/RequestsReview?page=مشاهده درخواست ها");
				break;
			case 4:
				navigate("/Employee/ConstView?page=مشاهده آخرین پروانه");
				break;
			case 5:
				navigate("/Employee/CertificateView?page=مشاهده آخرین گواهی");
				break;
			case 6:
				navigate("/Employee/LettersView?page=مشاهده نامه نگاری ها");
				break;
			case 7:
				navigate("/Employee/ArchiveList?page=لیست آرشیو الکترونیکی");
				break;
		}
	}

	const DataGrid = () => {
		return (
			<GridControl
				data={getServiceResult}
				customHeaders={{ "FileNumber": "شماره پرونده", "RenovationCode": "کد نوسازی", "FileStatus": "وضعیت", "Address": "آدرس", "ComboBox": "عملیات" }}
				ComboBox={ComboBox}
			/>
		)
	}

	const SetTypeLevel = (val) => {
		ServiceUrlCheckBox = val;
		ClearRefInput();
		setServiceResult([]);

		setFileNumberState(true);
		setRegistrationPlateState(true);
		setRenewalCodeState(true);
		setOldRenovationCodeState(true);
		setOwnerNameState(true);
		setOwnerAddressState(true);
		setPostalCodeState(true);
		setNationalCodeState(true);

		if (val == 'GetFilesByFileNumber')
			setFileNumberState(false);
		if (val == 'GetFilesByRegistrationPlate')
			setRegistrationPlateState(false);
		if (val == 'GetFilesByRenovationCode')
			setRenewalCodeState(false);
		if (val == 'GetFilesByOldRenovationCode')
			setOldRenovationCodeState(false);
		if (val == 'GetFilesByOwnerName')
			setOwnerNameState(false);
		if (val == 'GetFilesByAddress')
			setOwnerAddressState(false);
		if (val == 'GetFilesByPostalCode')
			setPostalCodeState(false);
		if (val == 'GetFilesByNationalCode')
			setNationalCodeState(false);
	}

	const handleCustomTab = (e, nextRef) => {
		if (e.key === "Tab" && !e.shiftKey) {
			e.preventDefault();
			nextRef.current?.focus();
		}
	};

	return (
		<div class="text-center my-4">
			<table dir="rtl" style={{ "width": "100%" }}>
				<tbody>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByFileNumber')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>شماره پرونده</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp1Ref}
								disabled={getFileNumberState}
								placeholder="شماره پرونده"
							/>
						</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByRegistrationPlate')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>پلاک ثبتی</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp2Ref}
								onKeyDown={(e) => handleCustomTab(e, btnSearchRef)}
								disabled={getRegistrationPlateState}
								placeholder="کد قطعه"
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp3Ref}
								disabled={getRegistrationPlateState}
								placeholder="کد فرعی"
								onKeyDown={(e) => handleCustomTab(e, inp2Ref)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp4Ref}
								onKeyDown={(e) => handleCustomTab(e, inp3Ref)}
								disabled={getRegistrationPlateState}
								placeholder="کد اصلی"
							/>
						</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByRenovationCode')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>کدنوسازی</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp5Ref}
								disabled={getRenewalCodeState}
								placeholder="آپارتمان"
								onKeyDown={(e) => handleCustomTab(e, btnSearchRef)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp6Ref}
								disabled={getRenewalCodeState}
								placeholder="ملک"
								onKeyDown={(e) => handleCustomTab(e, inp5Ref)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp7Ref}
								disabled={getRenewalCodeState}
								placeholder="بلوک"
								onKeyDown={(e) => handleCustomTab(e, inp6Ref)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp8Ref}
								disabled={getRenewalCodeState}
								placeholder="ناحیه"
								onKeyDown={(e) => handleCustomTab(e, inp7Ref)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp9Ref}
								disabled={getRenewalCodeState}
								placeholder="منطقه"
								onKeyDown={(e) => handleCustomTab(e, inp8Ref)}
							/>
						</td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByOldRenovationCode')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>کدنوسازی قدیم</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp10Ref}
								disabled={getOldRenovationCodeState}
								placeholder="آپارتمان"
								onKeyDown={(e) => handleCustomTab(e, btnSearchRef)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp11Ref}
								disabled={getOldRenovationCodeState}
								placeholder="ملک"
								onKeyDown={(e) => handleCustomTab(e, inp10Ref)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp12Ref}
								disabled={getOldRenovationCodeState}
								placeholder="بلوک"
								onKeyDown={(e) => handleCustomTab(e, inp11Ref)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp13Ref}
								disabled={getOldRenovationCodeState}
								placeholder="ناحیه"
								onKeyDown={(e) => handleCustomTab(e, inp12Ref)}
							/>
						</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp14Ref}
								disabled={getOldRenovationCodeState}
								placeholder="منطقه"
								onKeyDown={(e) => handleCustomTab(e, inp13Ref)}
							/>
						</td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByOwnerName')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>نام مالک</td>
						<td style={{ "width": "50px" }} colspan="5">
							<TextBoxControl
								required={true}
								maxlength={11}
								inputRef={inp15Ref}
								disabled={getOwnerNameState}
								placeholder="نام مالک"
							/>
						</td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByAddress')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>نشانی ملک</td>
						<td style={{ "width": "50px" }} colspan="5">
							<TextBoxControl
								required={true}
								maxlength={11}
								inputRef={inp16Ref}
								disabled={getOwnerAddressState}
								placeholder="نشانی ملک"
							/>
						</td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByPostalCode')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>کد پستی</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp17Ref}
								disabled={getPostalCodeState}
								placeholder="کد پستی"
							/>
						</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByNationalCode')} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>کد ملی</td>
						<td style={{ "width": "50px" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								inputRef={inp18Ref}
								disabled={getNationalCodeState}
								placeholder="کد ملی"
							/>
						</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td colspan="7" className="text-end">
							<div className="w-75" style={{ float: 'left' }}>
								<ButtonControl
									inputRef={btnSearchRef}
									variant="primary w-25"
									title="جستجو"
									onClick={BtnGetServiceResult}
									icon="fa fa-search"
								/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>

			<hr />

			<DataGrid />
		</div>
	);
}
